import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import { getResponse, pageState } from '../recoil/state/page'

import { MessageBox, MESSAGE_BOX_VARIANT_DANGER } from 'mailup-web-components'
import Details from './Details'

const MessageBoxError = () => {
  const intl = useIntl()

  const { Details: details } = useRecoilValue(getResponse)
  const setPageState = useSetRecoilState(pageState)

  return (
    <MessageBox
      variant={MESSAGE_BOX_VARIANT_DANGER}
      closeButton
      closeButtonCallback={() => {
        setPageState(prev => ({
          ...prev,
          boxError: false
        }))
      }}
      data-mu-test='message-box-error'
    >
      {intl.formatMessage({
        id: 'Load.EmailMessageImport.dangerMessageNew'
      })}

      <>
        {details.map((e, index) => (
          <Details
            key={index}
            index={index}
            detailCode={e.Code}
            detailArray={e.Items}
          />
        ))}
      </>
    </MessageBox>
  )
}

export default MessageBoxError
